/** @format */

import { takeLeading, put, all, call, select } from 'redux-saga/effects';
import {
  fetchMessageHistorySuccess,
  fetchMessageHistoryFailure,
} from './message-history.actions';
import { selectSelectedFlightIds } from '../flightData/flightData.selector';
import { selectCurrentUser } from '../user/user.selector';
import axios from 'axios';

export function* fetchMessageHistory() {
  try {
    const flightIds = yield select(selectSelectedFlightIds);
    const currentUser = yield select(selectCurrentUser);
    const messageHistory = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/messagehistory',
      method: 'post',
      data: {
        flightIds: flightIds,
        userAuth: currentUser,
      },
    });
    yield put(fetchMessageHistorySuccess(messageHistory.data.data));
  } catch (error) {
    yield put(fetchMessageHistoryFailure(error.message));
  }
}

export function* onFetchMessageHistoryStart() {
  yield takeLeading('FETCH_MESSAGE_HISTORY_START', fetchMessageHistory);
}

export function* messageHistorySagas() {
  yield all([call(onFetchMessageHistoryStart)]);
}
